import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Services', path: '/services' },
  { label: 'Appointment', path: '/book-appointment' },
  { label: 'Resources', path: '/patient-resources' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-zinc-900/98 backdrop-blur-md border-b border-zinc-800' : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/856ce707-63c2-4323-8fd2-5d8634add062.png"
            alt="AxisPoint Medical Logo"
            className="h-10 w-auto object-contain brightness-0 invert"
          />
          <span
            className="text-white font-black text-lg whitespace-nowrap hidden sm:block"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            AxisPoint <span className="text-rose-400">Medical</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2 text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer rounded-full ${
                  isActive
                    ? 'bg-white/15 text-white'
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            to="/book-appointment"
            className="ml-3 px-6 py-2.5 text-sm font-bold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer bg-rose-500 text-white hover:bg-rose-400"
          >
            Book Now
          </Link>
        </nav>

        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl text-white`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-zinc-900 border-t border-zinc-800 px-6 py-5 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="px-4 py-3 text-zinc-300 font-medium rounded-xl hover:bg-zinc-800 hover:text-white transition-colors cursor-pointer text-sm"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/book-appointment"
            className="mt-3 px-5 py-3 bg-rose-500 text-white text-sm font-bold rounded-full text-center hover:bg-rose-400 transition-colors cursor-pointer"
          >
            Book Now
          </Link>
        </div>
      )}
    </header>
  );
}
